<!-- Idea Modal Header Start-->
<div class="modal-header cluster-manager-modal">
  <h2 class="modal-title d-xs-none d-md-block">Cluster Manager</h2>
  <button
    type="button"
    (click)="dismiss()"
    class="btn-close"
    title="Close"></button>
</div>
<!-- Idea Modal Header End-->

<!-- Idea Modal Body Start-->
<div class="modal-body idea-modal clearfix">
  <ul class="nav nav-tabs">
    <li [ngClass]="{ active: mode === 'selectCluster' }">
      <a data-toggle="tab" href="#" (click)="selectMode('selectCluster')">
        Select Cluster
      </a>
    </li>
    <li [ngClass]="{ active: mode === 'generateCluster' }">
      <a data-toggle="tab" href="#" (click)="selectMode('generateCluster')">
        Generate Cluster
      </a>
    </li>
    <li [ngClass]="{ active: mode === 'syncIdeas' }">
      <a data-toggle="tab" href="#" (click)="selectMode('syncIdeas')">
        Sync Ideas
      </a>
    </li>
    <li [class.active]="mode === 'importWordList'">
      <a data-toggle="tab" href="#" (click)="selectMode('importWordList')">
        Import Words
      </a>
    </li>
    <li [class.active]="mode === 'importDocumentList'">
      <a data-toggle="tab" href="#" (click)="selectMode('importDocumentList')">
        Import Dataset
      </a>
    </li>
    <li [class.active]="mode === 'datasets'">
      <a data-toggle="tab" href="#" (click)="selectMode('datasets')">
        Datasets
      </a>
    </li>
    <li [class.active]="mode === 'reset'">
      <a data-toggle="tab" href="#" (click)="selectMode('reset')">Reset</a>
    </li>
  </ul>
  <div class="row content">
    <ng-container *ngIf="mode === 'selectCluster' && availableDatasets">
      <div class="col-lg-12">
        <table class="table">
          <thead>
            <tr>
              <th>Dataset</th>
              <th>Base Dataset</th>
              <th>Clustering-Algorithm</th>
              <th>Cluster-Size</th>
              <th>Dimensionality Reduction</th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngFor="let configuration of clusterConfigurations">
              <tr [class.highlighted]="isSelectedConfiguration(configuration)">
                <td>{{ configuration['target_dataset'] }}</td>
                <td>{{ configuration['source_dataset'] }}</td>
                <td>
                  {{
                    configuration['clustering_algorithm']
                      .toUpperCase()
                      .replace('_', ' ')
                  }}
                </td>
                <td>{{ configuration['cluster_size'] }}</td>
                <td>
                  {{
                    configuration['dimensionality_reduction']
                      .toUpperCase()
                      .replace('_', ' ')
                  }}
                </td>
                <td>
                  <div
                    class="btn btn-primary btn-sm"
                    [ngClass]="{ disabled: requestInProgress }"
                    (click)="
                      !requestInProgress &&
                        openClusterConfiguration(configuration)
                    ">
                    Open
                  </div>
                </td>
                <td>
                  <div
                    class="btn btn-primary btn-sm"
                    [ngClass]="{ disabled: requestInProgress }"
                    (click)="
                      !requestInProgress &&
                        computeClusterConfiguration(configuration)
                    ">
                    Recompute
                  </div>
                </td>
                <td>
                  <ng-container *ngIf="configuration['is_default']">
                    <div class="btn btn-secondary btn-sm disabled">DEFAULT</div>
                  </ng-container>
                  <ng-container *ngIf="!configuration['is_default']">
                    <div
                      class="btn btn-primary btn-sm"
                      [ngClass]="{ disabled: requestInProgress }"
                      (click)="
                        !requestInProgress && markDefault(configuration)
                      ">
                      Mark Default
                    </div>
                  </ng-container>
                </td>
                <td>
                  <div
                    class="btn btn-danger btn-sm fa fa-trash"
                    [ngClass]="{ disabled: requestInProgress }"
                    (click)="
                      !requestInProgress && deleteCluster(configuration)
                    "></div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </ng-container>
    <ng-container *ngIf="mode === 'reset'">
      <div class="col-lg-12">
        <div class="btn btn-primary" (click)="resetDatabase()">Reset All</div>
        <div style="margin-top: 10px">
          <i>
            Resets all Datasets, Wordlists, Documents, Clusters, Pixabay
            Pictures, and Pixabay Caches
          </i>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="mode === 'generateCluster'">
      <div>
        <div class="col-lg-4">
          <div class="form-group mb-3">
            <label class="form-label" for="clusteringAlgorithm">
              Clustering Algorithm:
            </label>
            <select
              class="form-control"
              id="clusteringAlgorithm"
              [(ngModel)]="newClusterConfiguration['clustering_algorithm']">
              <option>NMF</option>
              <option>LDA</option>
              <option>KMEANS</option>
            </select>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="form-group mb-3" *ngIf="availableDatasets">
            <label class="form-label" for="targetDataset">Dataset:</label>
            <select
              class="form-control"
              id="targetDataset"
              [(ngModel)]="newClusterConfiguration['target_dataset']">
              <ng-container *ngFor="let dataset of availableDatasets">
                <option>{{ dataset }}</option>
              </ng-container>
            </select>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="form-group mb-3" *ngIf="availableDatasets">
            <label class="form-label" for="sourceDataset">Base Dataset:</label>
            <select
              class="form-control"
              id="sourceDataset"
              [(ngModel)]="newClusterConfiguration['source_dataset']">
              <ng-container *ngFor="let dataset of availableDatasets">
                <option>{{ dataset }}</option>
              </ng-container>
            </select>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="form-group mb-3">
            <label class="form-label" for="clusterSize">Clustersize:</label>
            <input
              class="form-control"
              type="number"
              id="clusterSize"
              name="clusterSize"
              min="1"
              max="200"
              [(ngModel)]="newClusterConfiguration['cluster_size']" />
          </div>
        </div>

        <div class="col-lg-4">
          <div class="form-group mb-3">
            <label class="form-label" for="reductionAlgorithm">
              Dimensionality Reduction Algorithm:
            </label>
            <select
              class="form-control"
              id="reductionAlgorithm"
              [(ngModel)]="newClusterConfiguration['dimensionality_reduction']">
              <option>TSNE</option>
              <option>UMAP</option>
            </select>
          </div>
        </div>
        <div
          class="col-lg-4"
          *ngIf="getSelectedClusteringAlgorithm() === 'KMEANS'">
          <div class="form-group mb-3">
            <label class="form-label" for="wordList">WordList:</label>
            <select
              class="form-control"
              id="wordList"
              [(ngModel)]="newClusterConfiguration['word_list']">
              <ng-container *ngFor="let wordList of wordLists">
                <option>{{ wordList }}</option>
              </ng-container>
            </select>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group mb-3">
            <label class="form-label" for="wordList">Additional Dataset:</label>
            <select
              class="form-control"
              id="wordList"
              [(ngModel)]="newClusterConfiguration['additional_dataset']">
              <ng-container *ngFor="let dataset of additionalDatasets">
                <option>{{ dataset }}</option>
              </ng-container>
            </select>
          </div>
        </div>
        <div class="col-lg-12">
          <div
            class="btn btn-primary"
            [ngClass]="{ disabled: requestInProgress }"
            (click)="!requestInProgress && createNewCluster()">
            Create new Cluster
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="mode === 'syncIdeas'">
      <app-sync-ideas
        [(requestInProgress)]="requestInProgress"></app-sync-ideas>
    </ng-container>
    <ng-container *ngIf="mode === 'importWordList'">
      <div class="col-lg-12 form-group mb-3">
        <input
          class="form-control"
          type="file"
          accept=".csv"
          (change)="handleFileSelectWordList($event)" />
        <input
          class="form-control"
          type="text"
          [(ngModel)]="wordListName"
          placeholder="Name of the Wordlist" />
        <div
          [class.disabled]="
            requestInProgress || !wordListName || !selectedWordListFile
          "
          class="btn btn-primary"
          (click)="importWordList()">
          Import Words
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="mode === 'importDocumentList'">
      <app-import-dataset
        [(requestInProgress)]="requestInProgress"></app-import-dataset>
    </ng-container>
    <ng-container *ngIf="mode === 'datasets'">
      <div class="col-lg-12">
        <app-dataset-list></app-dataset-list>
      </div>
    </ng-container>
  </div>
</div>

<div class="modal-footer">
  <div
    class="btn btn-secondary"
    [ngClass]="{ disabled: requestInProgress }"
    (click)="dismiss()">
    Close
  </div>
</div>

<!-- Idea Modal Body End-->
